export const DEFAULT_WORKFLOW_STATUS = 'pendente_inicio';
export const DEFAULT_INTERACTION_PHASE = 'carregando_video';

export const resolveStatusModelVersion = (interviewTypeKey = 'pesquisa-de-compliance', existingVersion) => {
  if (existingVersion === 'v2') return 'v2';
  if (interviewTypeKey === 'pesquisa-de-compliance') return 'legacy';
  return 'v2';
};

export const buildStatusPayload = ({
  interviewTypeKey,
  workflowStatus = DEFAULT_WORKFLOW_STATUS,
  interactionPhase = DEFAULT_INTERACTION_PHASE,
  statusModelVersion
}) => {
  return {
    workflowStatus,
    interactionPhase,
    statusModelVersion: resolveStatusModelVersion(interviewTypeKey, statusModelVersion)
  };
};
